// ** React Imports
import { lazy } from 'react';

const EmailPreviewRoutes = [
  {
    path: 'settings/email-previews',
    component: lazy(() => import('views/email-previews')),
  },
];

export default EmailPreviewRoutes;
